import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";

export default function ThankYou() {
  const { slug } = useParams();
  const { t } = useTranslation();
  const [campaign, setCampaign] = useState(null);

  useEffect(() => {
    if (!slug) return;
    api.get(`/public/campaigns/${slug}`).then((r) => setCampaign(r.data)).catch(() => {});
  }, [slug]);

  const custom = campaign?.thankyou_message?.trim();

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-6">
      <div className="text-center fade-up max-w-md" data-testid="thank-you-screen">
        <CheckCircle2 size={56} className="text-[#FF4F00] mx-auto mb-6" />
        <h1 className="font-heading font-extrabold text-3xl sm:text-4xl tracking-tight">{t("thankyou.title")}</h1>
        {custom ? (
          <p data-testid="thank-you-custom-message" className="text-zinc-600 mt-4 mx-auto leading-relaxed whitespace-pre-wrap">
            {custom}
          </p>
        ) : (
          <p className="text-zinc-600 mt-4 mx-auto leading-relaxed">
            {t("thankyou.defaultMsg")}
          </p>
        )}
        <p className="text-xs text-zinc-400 mt-8">{t("thankyou.closeHint")}</p>
      </div>
    </div>
  );
}
